import { logQueueActionEvent } from "./logQueueActionEvent";
import type { QueueActionType } from "../properties/event/queueActionProperties";
import { getDesktopQueueOpen } from "components/shared/hooks";

export function logOpenCloseQueueViewEvent() {
    const queueOpen = getDesktopQueueOpen();
    const type: QueueActionType = queueOpen ? "OpenQueueView" : "CloseQueueView";
    logQueueActionEvent(type, queueOpen);
}
